import React, { Component, useEffect, useState } from "react";
import ComponentForgotPasswordOTPMobile from "./ComponentForgotPasswordOTPMobile";
import ComponentForgotPasswordOTPWeb from "./ComponentForgotPasswordOTPWeb";
import { BrowserView, MobileView } from "react-device-detect";
import useAnalyticsEventTracker from "../../core/service/useAnalyticsEventTracker";
import ReactGA from "react-ga4";
const ComponentForgotPasswordOTP = () => {
  const gaEventTracker = useAnalyticsEventTracker("ForgotPasswordOTP");
  useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: window.location.pathname + window.location.search,
      title: "Forgot Password TOP",
    });
  }, []);
  return (
    <>
      <BrowserView>
        <ComponentForgotPasswordOTPWeb></ComponentForgotPasswordOTPWeb>
      </BrowserView>
      <MobileView>
        <ComponentForgotPasswordOTPMobile></ComponentForgotPasswordOTPMobile>
      </MobileView>
    </>
  );
};

export default ComponentForgotPasswordOTP;
